export default __webpack_public_path__ + "static/media/time.f1d3c982.svg";